// extracted by mini-css-extract-plugin
export default {"form":"LoginGrid_form__oCll+","title":"LoginGrid_title__-rwHC","link":"LoginGrid_link__1Rxan","input-text":"LoginGrid_input-text__bkCOx","or":"LoginGrid_or__t9ApT"};